import * as buildinfo from "virtual:buildinfo"

import { AuthClientInstance } from "@/lib/services/instances"

import { payloadEnricher } from "./-events/payloadEnricher"
import type { TrackingEvent } from "./-events/trackingEvents"

type EmitEvent<K extends keyof TrackingEvent> =
  TrackingEvent[K] extends Record<string, unknown>
    ? { type: K; payload: TrackingEvent[K] }
    : { type: K; payload?: undefined }

/** GA4 event emitter */
export async function ga4Emitter<K extends keyof TrackingEvent>({ type, payload }: EmitEvent<K>) {
  const user = await AuthClientInstance.getUser()

  if (!user) return // If the user is not logged in, don't track anything

  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      page_location: window.location.href,
      page_title: document.title,
      ...payloadEnricher(type),
      ...payload,
      site_area: "app_arduino",
      ...(user["http://arduino.cc/is_minor"] && { userkind: "minor" }),
      platform: "web",
      app_version: buildinfo.version,
      user: {
        id: user["http://arduino.cc/id"],
        email: user.email
      },
      user_id: user["http://arduino.cc/id"]
    })
  } catch {
    console.error(`Error tracking event [${type}] with args [${JSON.stringify(payload)}]`)
  }
}
